import { Typography } from '@material-ui/core';
import { alpha, makeStyles } from '@material-ui/core/styles';
import ReportProblemOutlined from '@material-ui/icons/ReportProblemOutlined';
import { useTranslation } from 'react-i18next';

const CARD_RADIUS = 8;
// Tints derive from the brand colour (`theme.palette.common.yellow`) rather than the green accent, matching
// the empty-state alert card — and so white-label primaryColor overrides apply.
const ALERT_TINT_BG_OPACITY = 0.08;
const ALERT_TINT_BORDER_OPACITY = 0.35;

const useStyles = makeStyles((theme) => ({
    card: {
        backgroundColor: alpha(theme.palette.common.yellow, ALERT_TINT_BG_OPACITY),
        border: `1px solid ${alpha(theme.palette.common.yellow, ALERT_TINT_BORDER_OPACITY)}`,
        borderRadius: CARD_RADIUS,
        padding: 20,
        boxSizing: 'border-box',
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
    },
    icon: {
        color: theme.palette.common.yellow,
    },
    heading: {
        fontSize: '1.125rem',
        color: theme.palette.common.darkGrey,
        fontWeight: 700,
    },
    list: {
        margin: '12px 0 0',
        paddingLeft: 20,
        fontSize: '0.9375rem',
        color: theme.palette.common.darkGrey,
    },
    item: {
        marginBottom: 8,
        '&:last-child': {
            marginBottom: 0,
        },
    },
}));

const ChainPostBookingInfo = () => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <div className={classes.card} data-testid="chain-post-booking-info">
            <div className={classes.header}>
                <ReportProblemOutlined className={classes.icon} aria-hidden="true" />
                <Typography variant="h3" className={classes.heading}>
                    {t('ChainPostBookingHeading')}
                </Typography>
            </div>
            <ul className={classes.list}>
                <Typography variant="inherit" component="li" className={classes.item}>
                    {t('ChainPostBookingBullet1')}
                </Typography>
                <Typography variant="inherit" component="li" className={classes.item}>
                    {t('ChainPostBookingBullet2')}
                </Typography>
                <Typography variant="inherit" component="li" className={classes.item}>
                    {t('ChainPostBookingBullet3')}
                </Typography>
                <Typography variant="inherit" component="li" className={classes.item}>
                    {t('ChainPostBookingBullet4')}
                </Typography>
            </ul>
        </div>
    );
};

export default ChainPostBookingInfo;
